import styled from 'styled-components';
import PendingRequestSvg from '../../assets/header/pending_request.svg';

const PendingRequestIcon = styled(PendingRequestSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
    width: ${props => props.width || '2.4rem'};
    height: ${props => props.height || '2.4rem'};
`;

export default PendingRequestIcon;
